import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { supabase } from '../lib/supabase';

interface Props {
  adminName: string;
  onLogout: () => void;
}

export function Layout({ adminName, onLogout }: Props) {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    // Test Supabase connection
    supabase.from('bars').select('id', { count: 'exact', head: true })
      .then(({ error }) => setConnected(!error));
  }, []);

  return (
    <div className="app-layout">
      <Sidebar adminName={adminName} onLogout={onLogout} />
      <div className="app-main">
        <Header adminName={adminName} connected={connected} />
        <div className="app-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
